<template>
  <select class="form-control" 
    :name="name" 
    :value="filters.sort" 
    :disabled="isDisabled"
    @change="setFilter"
  >
    <slot></slot>
  </select>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },

    filters: {
      type: Object,
      required: true
    },

    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isDisabled: false,
    }
  },

  computed: {
    filterValue() {
      return this.filters[this.name]
    },
  },

  methods: {
    setFilter(event) {
      this.isDisabled = ! this.callback(event.target.value, this.name)
    }
  }
}
</script>